let ShipmentsOrderBy = /*#__PURE__*/function (ShipmentsOrderBy) {
  ShipmentsOrderBy["SERVICE_ASC"] = "service_asc";
  ShipmentsOrderBy["SERVICE_DESC"] = "service_desc";
  return ShipmentsOrderBy;
}({});

/**
 * Params needed for GET request to /pro/shipments
 *
 */

export { ShipmentsOrderBy };
//# sourceMappingURL=ShipmentParams.js.map
